export const isNotValid = (inputValue) => {
    const reg = /^.*<[^>]+>[^<]+<\/[^>]+>.*$/i;
    return reg.test(inputValue);
}